import type { IconNode } from '../types';

/**
 * @name sushi-chopsticks
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMiAxOFYyIiAvPgogIDxwYXRoIGQ9Ik0yMiAxOFYyIiAvPgogIDxwYXRoIGQ9Ik02IDExYzAtMi44IDIuMi01IDUtNWgyYzIuOCAwIDUgMi4yIDUgNXY2YzAgMi44LTIuMiA1LTUgNWgtMmMtMi44IDAtNS0yLjItNS01WiIgLz4KICA8cGF0aCBkPSJNMTggMTNjMCAyLjgtMi4yIDUtNSA1aC0yYy0yLjggMC01LTIuMi01LTUiIC8+CiAgPHBhdGggZD0iTTExIDE0Yy0uNiAwLTEtLjQtMS0xdi0yYzAtLjYuNC0xIDEtMWgyYy42IDAgMSAuNCAxIDF2MmMwIC42LS40IDEtMSAxWiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/sushi-chopsticks
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const sushiChopsticks: IconNode = [
  ['path', { d: 'M2 18V2', key: '14aqy7' }],
  ['path', { d: 'M22 18V2', key: 'swhaje' }],
  [
    'path',
    {
      d: 'M6 11c0-2.8 2.2-5 5-5h2c2.8 0 5 2.2 5 5v6c0 2.8-2.2 5-5 5h-2c-2.8 0-5-2.2-5-5Z',
      key: 'o42fq',
    },
  ],
  ['path', { d: 'M18 13c0 2.8-2.2 5-5 5h-2c-2.8 0-5-2.2-5-5', key: '1riyq0' }],
  [
    'path',
    { d: 'M11 14c-.6 0-1-.4-1-1v-2c0-.6.4-1 1-1h2c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1Z', key: '1qtmyi' },
  ],
];

export default sushiChopsticks;
